import React, { useState } from 'react'
import styles from './BillingMilestones.module.css'

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="8.5" stroke="#6524EB" strokeWidth="1.7" />
    <path d="M12 7.5V12l3 1.8" stroke="#6524EB" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
    <path d="M5 13l4 4L19 7" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const BillingMilestones = ({
  // DATA — always supplied by the parent from real invoices/upcoming. No fake
  // fallback: empty until the real data arrives.
  milestones = [],
  note = '',
  // When provided, the header ›arrow navigates to the full Billing History
  // (all invoices) instead of just collapsing.
  onSeeAll,
}) => {
  const [open, setOpen] = useState(true)

  return (
    <div className={styles.card}>
      <button
        type="button"
        className={styles.head}
        onClick={() => (onSeeAll ? onSeeAll() : setOpen((prev) => !prev))}
        aria-expanded={open}
      >
        <h3 className={styles.title}>Billing Milestones</h3>
        <span className={styles.chevron}>›</span>
      </button>

      <div className={`${styles.collapse} ${open ? styles.collapseOpen : ''}`}>
        <div className={styles.collapseInner}>
          {milestones.map((m) => (
            <div key={m.id} className={styles.row}>
              <span className={`${styles.icon} ${m.done ? styles.iconDone : styles.iconPending}`}>
                {m.done ? <CheckIcon /> : <ClockIcon />}
              </span>
              <div className={styles.rowBody}>
                <p className={styles.rowTitle}>{m.title}</p>
                <p className={styles.rowSub}>{m.sub}</p>
              </div>
              <div className={styles.rowRight}>
                <p className={styles.amount}>{m.amount}</p>
                <p className={`${styles.status} ${m.done ? styles.paid : styles.ongoing}`}>{m.status}</p>
              </div>
            </div>
          ))}

          {note ? (
            <div className={styles.note}>
              <span className={styles.noteIcon}>i</span>
              <p className={styles.noteText}>{note}</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default BillingMilestones
